module.exports = __webpack_public_path__ + "media/assets/images/logos/velex_logo-dd268bf95e3a979a57a8cbac7e487971.png";